import {
  AcademicCapIcon as AcademicCap,
  ArrowDownOnSquareStackIcon as ArrowDownOnSquareStack,
  BookmarkIcon as Bookmark,
  BookOpenIcon as BookOpen,
  CalendarDaysIcon as CalendarDays,
  ChatBubbleBottomCenterTextIcon as ChatBubbleBottomCenterText,
  DocumentTextIcon as DocumentText,
  EnvelopeIcon as Envelope,
  ExclamationCircleIcon as ExclamationCircle,
  GlobeAltIcon as GlobeAlt,
  MicrophoneIcon as Microphone,
  PencilSquareIcon as PencilSquare,
  PlayIcon as Play,
  UserGroupIcon as UserGroup,
  WrenchScrewdriverIcon as WrenchScrewdriver,
  XMarkIcon as XMark,
} from "@heroicons/react/24/solid";

type CustomIconProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

export const Icons = {
  AcademicCap,
  ArrowDownOnSquareStack,
  BookOpen,
  Bookmark,
  CalendarDays,
  ChatBubbleBottomCenterText,
  DocumentText,
  Envelope,
  ExclamationCircle,
  GlobeAlt,
  Microphone,
  PencilSquare,
  Play,
  UserGroup,
  WrenchScrewdriver,
  XMark,
  // Custom icons
  Facebook: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 4.5c-4.142 0-7.5 3.37-7.5 7.528a7.525 7.525 0 0 0 5.688 7.306v-5.006H8.642v-2.3h1.546v-.992c0-2.562 1.155-3.75 3.662-3.75.475 0 1.295.094 1.63.188v2.085a9.588 9.588 0 0 0-.867-.028c-1.23 0-1.704.467-1.704 1.683v.814h2.45l-.421 2.3h-2.03V19.5c3.714-.45 6.592-3.624 6.592-7.472C19.5 7.87 16.142 4.5 12 4.5Z"
      />
    </svg>
  ),
  Headphones: (props: CustomIconProps) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3 10V15.4444C3 16.3 3.7 17 4.55556 17H6.11111C6.96667 17 7.66667 16.3 7.66667 15.4444V12.3333C7.66667 11.4778 6.96667 10.7778 6.11111 10.7778H4.55556V10C4.55556 6.99 6.99 4.55556 10 4.55556C13.01 4.55556 15.4444 6.99 15.4444 10V10.7778H13.8889C13.0333 10.7778 12.3333 11.4778 12.3333 12.3333V15.4444C12.3333 16.3 13.0333 17 13.8889 17H15.4444C16.3 17 17 16.3 17 15.4444V10C17 8.14348 16.2625 6.36301 14.9497 5.05025C13.637 3.7375 11.8565 3 10 3C8.14348 3 6.36301 3.7375 5.05025 5.05025C3.7375 6.36301 3 8.14348 3 10Z" />
    </svg>
  ),
  Instagram: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.062 19.438c2.75-.126 4.25-1.626 4.375-4.376.063-.75.063-1 .063-3.062 0-2.063 0-2.312-.063-3.062-.125-2.75-1.625-4.25-4.375-4.376-.75-.062-1-.062-3.063-.062-2.062 0-2.313 0-3.063.062-2.75.125-4.25 1.625-4.375 4.376-.063.75-.063 1-.063 3.062s0 2.312.063 3.062c.126 2.75 1.626 4.25 4.375 4.376.75.062 1 .062 3.063.062s2.313 0 3.063-.062Zm0-13.5c-.812-.064-1.061-.064-3.062-.064-2 0-2.25 0-3 .064A2.795 2.795 0 0 0 5.938 9c-.063.75-.063 1-.063 3s0 2.188.063 3c.062 2 1 3 3.062 3.062.75.063 1 .063 3 .063 2.063 0 2.25 0 3.063-.063a2.799 2.799 0 0 0 2.915-1.842c.138-.391.189-.808.148-1.22.063-.75.063-1 .063-3s0-2.188-.063-3c-.063-2-1-2.999-3.063-3.06Zm.16 8.215a3.875 3.875 0 1 1-3.22-6.028 3.897 3.897 0 0 1 3.875 3.876 3.87 3.87 0 0 1-.654 2.153ZM16.62 8.62a.874.874 0 0 1-1.493-.618.856.856 0 0 1 .875-.876.856.856 0 0 1 .876.876.875.875 0 0 1-.256.618h-.002Zm-3.662 1.072a2.496 2.496 0 0 0-2.723.54A2.5 2.5 0 0 0 12 14.5a2.507 2.507 0 0 0 2.5-2.5 2.498 2.498 0 0 0-1.542-2.308Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  Linkedin: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19.167 19.068a1.1 1.1 0 0 0 .332-.771l.001-.001V5.595a1.096 1.096 0 0 0-1.11-1.08H5.608A1.093 1.093 0 0 0 4.5 5.595v12.702a1.095 1.095 0 0 0 1.107 1.082h12.78c.29.004.571-.109.78-.31Zm-5.766-8.704c.37-.203.79-.302 1.212-.286 2.253 0 2.67 1.482 2.668 3.409v3.926H15.06v-3.48c0-.83-.015-1.899-1.156-1.899-1.158 0-1.335.905-1.335 1.838v3.54h-2.223v-7.156h2.134v.977h.03c.213-.365.521-.665.892-.869Zm-4.452-.108H6.724v7.157H8.95v-7.157ZM6.913 7.029a1.4 1.4 0 0 1 .924-.45l-.001.002a1.398 1.398 0 0 1 1.29 1.408 1.293 1.293 0 0 1-1.29 1.289 1.29 1.29 0 0 1-1.29-1.29 1.4 1.4 0 0 1 .367-.96Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  TikTok: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.757 6.608A4.314 4.314 0 0 1 15.795 3h-3.094l-.005 12.403a2.602 2.602 0 0 1-2.596 2.504 2.602 2.602 0 0 1-2.601-2.602 2.605 2.605 0 0 1 2.6-2.602c.268 0 .525.044.768.12V9.664a5.727 5.727 0 0 0-.768-.055 5.702 5.702 0 0 0-5.696 5.696c0 1.927.963 3.633 2.432 4.663a5.664 5.664 0 0 0 3.265 1.033 5.702 5.702 0 0 0 5.696-5.696v-6.29A7.362 7.362 0 0 0 20.1 10.4V7.305c-.864 0-1.669-.257-2.345-.697h.001Z"
      />
    </svg>
  ),
  Twitter: (props: CustomIconProps) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6.23492 18C13.7165 18 17.8085 11.8437 17.8085 6.50509C17.8085 6.33017 17.8086 6.15611 17.7967 5.98204C18.5927 5.41039 19.2799 4.70257 19.8261 3.89169C19.0837 4.21842 18.2962 4.43269 17.4898 4.52735C18.3389 4.02247 18.9744 3.22838 19.2781 2.29286C18.4796 2.76342 17.606 3.09505 16.6951 3.27342C16.0818 2.62574 15.2707 2.19687 14.3873 2.05317C13.5038 1.90947 12.5973 2.05896 11.8081 2.47849C11.0188 2.89803 10.3907 3.56423 10.0211 4.374C9.65142 5.18377 9.56079 6.09197 9.76319 6.95806C8.14597 6.87753 6.56388 6.46012 5.11962 5.73291C3.67537 5.00571 2.40123 3.98498 1.37993 2.73699C0.859763 3.62636 0.700438 4.6792 0.934392 5.68114C1.16835 6.68308 1.77799 7.5588 2.63919 8.13C1.99188 8.11094 1.35869 7.9375 0.793043 7.62433V7.67549C0.79329 8.60824 1.11839 9.5122 1.7132 10.234C2.308 10.9559 3.13589 11.4511 4.05645 11.6358C3.45759 11.798 2.82927 11.8217 2.21975 11.7051C2.47967 12.5079 2.98571 13.2099 3.6671 13.7129C4.34849 14.2159 5.17114 14.4949 6.02001 14.5107C4.57962 15.635 2.80029 16.2454 0.968303 16.2436C0.644665 16.2429 0.321343 16.2235 0 16.1853C1.86019 17.3709 4.02463 17.9998 6.23492 17.9968" />
    </svg>
  ),
  Youtube: (props: CustomIconProps) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.25 4C2.65326 4 2.08097 4.23705 1.65901 4.65901C1.23705 5.08097 1 5.65326 1 6.25V13.75C1 14.3467 1.23705 14.919 1.65901 15.341C2.08097 15.7629 2.65326 16 3.25 16H10.75C11.3467 16 11.919 15.7629 12.341 15.341C12.7629 14.919 13 14.3467 13 13.75V6.25C13 5.65326 12.7629 5.08097 12.341 4.65901C11.919 4.23705 11.3467 4 10.75 4H3.25ZM19 4.75C18.9999 4.60176 18.9558 4.45688 18.8734 4.33367C18.791 4.21045 18.6739 4.11442 18.5369 4.05771C18.4 4.001 18.2493 3.98615 18.1039 4.01503C17.9585 4.04392 17.8249 4.11524 17.72 4.22L14.72 7.22C14.5793 7.36052 14.5002 7.55115 14.5 7.75V12.25C14.5 12.449 14.579 12.64 14.72 12.78L17.72 15.78C17.8249 15.8848 17.9585 15.9561 18.1039 15.985C18.2493 16.0138 18.4 15.999 18.5369 15.9423C18.6739 15.8856 18.791 15.7895 18.8734 15.6663C18.9558 15.5431 18.9999 15.3982 19 15.25V4.75Z" />
    </svg>
  ),
  X: (props: CustomIconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m11.02 13.676 3.797 5.824h4.147l-5.639-8.649L18.51 4.5h-1.229l-4.502 5.515L9.183 4.5H5.036l5.437 8.34-5.437 6.66h1.229l4.755-5.824Z"
        clipRule="evenodd"
      />
    </svg>
  ),
} as const;
